import { render, staticRenderFns } from "./ApplyAddQualification.vue?vue&type=template&id=6da73412&scoped=true"
import script from "./ApplyAddQualification.vue?vue&type=script&lang=js"
export * from "./ApplyAddQualification.vue?vue&type=script&lang=js"
import style0 from "./ApplyAddQualification.vue?vue&type=style&index=0&id=6da73412&prod&scoped=true&lang=css"
import style1 from "./ApplyAddQualification.vue?vue&type=style&index=1&id=6da73412&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da73412",
  null
  
)

export default component.exports